// extracted by mini-css-extract-plugin
export default {"close":"Close_close__9T5DW","x":"Close_x__3W3JM"};